import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { FunnelStepService, SnitcherService } from '../../interfaces';
import { SnitcherServiceWithFunnelContext } from './SnitcherServiceWithFunnelContext';

export class SnitcherServiceBuilder {
  constructor(private snitcherService: SnitcherService) {}

  addFunnelContext(
    funnelSettingsService: FunnelSettingsServiceInterface,
    funnelStepService: FunnelStepService,
  ): this {
    this.snitcherService = new SnitcherServiceWithFunnelContext(
      this.snitcherService,
      funnelSettingsService,
      funnelStepService,
    );

    return this;
  }

  getResult(): SnitcherService {
    return this.snitcherService;
  }
}
